import { Component } from '@angular/core';

/**
 *
 * @class
 * CustomerSiteFixedBgComponent
 *
 *
 * @description
 * This component adds a fixed background to the site
 *
 */
@Component({
  selector: 'customer-site-fixed-bg',
  templateUrl: 'customer-site-fixed-bg.component.html',
  styleUrls: ['./customer-site-fixed-bg.component.scss']
})
export class CustomerSiteFixedBgComponent {}
